import {createAction} from '@reduxjs/toolkit'

import {
    CardCodeType,
    EasyCardItemTypeType,
    PaymentsCardCodeType,
    PromotionValidationSkipTypeType,
} from '@web/core/constants'

/** 간편 카드 선택 */
export const selectEasyCard = createAction<{
    /** 선택된 카드 간편결제 카드 ID */
    id: Maybe<string>
    /** 선택된 카드 할부기간 */
    installment?: string
    /** 카드 아이템 타입 */
    itemType?: EasyCardItemTypeType
}>('card/selectEasyCard')

/** 간편카드 할부 개월수 선택 */
export const selectEasyCardInstallment = createAction<string>('card/selectEasyCardInstallment')

/** 간편카드 카드사 포인트 사용 여부 선택 */
export const changePointUseOfSelectedEasyCardCorp = createAction<boolean>('card/changePointUseOfSelectedEasyCardCorp')

/** 간편카드 할부 개월수 초기화 */
export const resetEasyCardInstallment = createAction('card/resetEasyCardInstallment')

/** 신용카드 구분 선택 (개인, 법인) */
export const selectCreditCard = createAction<{
    /** 카드 구분 개인카드 | 법인카드 */
    type: CardCodeType
    /** 선택된 카드사 코드 */
    companyCode?: Maybe<PaymentsCardCodeType>
    /** 할부 기간 */
    installment?: string
}>('card/selectCreditCard')

/** 신용카드 카드사 선택 */
export const selectCreditCardCode = createAction<{
    /** 선택된 카드사 코드 */
    companyCode: Maybe<PaymentsCardCodeType>
    /** 할부 기간 */
    installment?: string
    /** 앱카드 사용가능 여부 */
    canUseAppCard?: boolean
}>('card/selectCreditCardCode')

/** 앱카드 직접호출 사용 여부 toggle  */
export const toggleUseAppCardDirectCall = createAction('card/toggleUseAppCardDirectCall')

/** 신용카드 할부 선택 */
export const selectCreditCardInstallment = createAction<string>('card/selectCreditCardInstallment')

/** 신용카드 할부 개월수 초기화 */
export const resetCreditCardInstallment = createAction('card/resetCreditCardInstallment')

/** 문화누리카드 카드사 선택 */
export const selectWelfareCard = createAction<{
    /** 선택된 카드사 코드 */
    companyCode: PaymentsCardCodeType | ''
}>('card/selectWelfareCard')

/** 프로모션 검증 건너뛰기 */
export const skipPromotionValidation = createAction<{skipType: PromotionValidationSkipTypeType}>(
    'card/skipPromotionValidation',
)

/** 프로모션 사용을 위한 간편계좌연결 취소 */
export const cancelConnectingPromotionAccount = createAction('card/cancelConnectingPromotionAccount')

/** 삼성페이 머니를 위함 임시 필드 배포후 제거 */
export const updateSamsungPayMoney = createAction<string[]>('card/updateSamsungPayMoney')
